module.exports = __webpack_public_path__ + "static/media/9DESA9.78e8468b.jpg";